var map = {
	"./konrad_px.png": 3900,
	"./ludwig_px.png": 8316,
	"./rr_px.png": 784,
	"./seher_px1.png": 670,
	"./seher_px3.jpg": 9202,
	"./seher_px3.png": 2243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8847;